module.exports = __webpack_public_path__ + "static/tw-follow-tab-32bffbae0c4ef7940e5c60fa7305ab4b.jpg";